export const detectWrap = (elemId) => {
  const elem = document.getElementById(elemId)
  if (!elem) return
  const firstSibling = [...elem.parentElement.children].find(
    (child) => child !== elem,
  )
  return firstSibling.offsetTop !== elem.offsetTop
}
